<template>
  <div>
    <transition name="esocial-modal-fade">
      <div class="esocial-modal-overlay" v-if="parent.showNovoXml" @click.self="close">
        <div class="esocial-modal esocial-modal--wide">
          <div class="esocial-modal__header">
            <span class="esocial-modal__title">Inserir novo XML</span>
            <button type="button" class="esocial-modal__close" @click="close">
              <i class="fa fa-times"></i>
            </button>
          </div>

          <div class="esocial-modal__body">
            <ed-form :model="formData">
          <ed-input-select
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
            label="Selecione um Layout"
            v-model="formData.layout"
            :items="getTabelas()"
            required
          />

          <ed-input-auto-complete
            class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pa-0"
            label="Empresa"
            name="id_emp"
            v-model="formData.empresa"
            :items="bind.empresas"
            :loading="bind.loadingEmpresa"
            :disabled="!formData.layout"
            @search="getEmpresa"
            @input="setEmpresa"
            clearable
            required
            is-object
          />

          <ed-input-auto-complete
            class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pa-0"
            label="Trabalhador (a)"
            name="id_fun"
            v-model="formData.funcionario"
            :items="bind.funcionarios"
            :loading="bind.loadingFuncionario"
            :disabled="!formData.id_emp"
            @search="getFuncionario"
            @input="setFuncionario"
            clearable
            required
            is-object
          />

          <ed-input-auto-complete
            v-if="formData.layout == 'S-2240'"
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pa-0"
            label="Frente de Trabalho"
            name="valor.id_fdt"
            v-model="formData.valor.id_fdt"
            :items="bind.fdt"
            :loading="bind.loadingFdt"
            :disabled="!formData.id_emp"
            @search="getFdt"
            clearable
            required
          />

          <ed-input-auto-complete
            class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pa-0"
            label="Categoria do Trabalhador"
            info="Somente se informado no evento de admissão do layout S-2200"
            v-model="formData.valor.id_esocial_categoria"
            :items="bind.categorias"
            :loading="bind.loadingCategoria"
            @search="getCategoria"
            clearable
          />

          <ed-input-text
            class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pa-0"
            label="Mátricula do Trabalhador"
            info="Somente se informado no evento de admissão do layout S-2200"
            v-model="formData.valor.matricula"
          />

          <s2220
            v-if="formData.layout == 'S-2220'"
            :formData="formData.valor"
            :parent="this"
            :avulso="1"
          />

          <s2240
            v-if="formData.layout == 'S-2240' && formData.id_emp && formData.id_fun && formData.valor.id_fdt"
            :formData="formData.valor"
            :parent="this"
            :avulso="1"
          />
        </ed-form>
          </div>

          <div class="esocial-modal__footer">
            <button type="button" class="esocial-search__btn esocial-search__btn--filter" @click="salvar">
              <i class="fa fa-check"></i> Salvar
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Fct from "common/fct";
import s2220 from "./s2220";
import s2240 from "./s2240";

import {
  EdForm,
  EdInputText,
  EdInputSelect,
  EdInputAutoComplete,
} from "template";

export default {
  name: "esocial-s2220",
  mixins: [Fct],
  components: {
    EdForm,
    EdInputText,
    EdInputSelect,
    EdInputAutoComplete,
    s2220,
    s2240,
  },

  props: {
    parent: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  conputed: {},

  watch: {
    "parent.response"() {
      this.formataLista();
    },
    "formData.id_emp"() {
      //this.formData.id_fun = null;

    },
    "parent.showNovoXml"() {
      this.initialize();
    },
  },

  data() {
    return {
      tableHead: [
        {
          key: "layout",
          sortable: true,
          label: "Layout",
        },
        {
          key: "empresa",
          sortable: true,
          show_fdt: true,
          show_empresa_link: true,
          label: "Empresa",
        },
        {
          key: "funcionario",
          sortable: true,
          show_funcao: true,
          show_funcionario_link: true,
          label: "Funcionário",
        },
        {
          key: "recibo",
          sortable: true,
          label: "Recibo",
        },
        {
          key: "lote",
          sortable: true,
          show_lote_link: true,
          label: "Lote",
        },
        {
          key: "tipo_status",
          sortable: true,
          label: "Status",
        },
        {
          key: "updated_at",
          sortable: true,
          show_user: true,
          label: "Data Atualização",
        },
      ],
      bind: {
        loadingEmpresa: false,
        loadingFuncionario: false,
        loadingCategoria: false,
        loadingFdt: false,
        funcionarios: [],
        empresas: [],
        estados: [],
        fdt: [],
        categorias: null,
      },
      response: null,
      formData: {
        id: 0,
        funcionario: null,
        empresa: null,
        id_emp: null,
        id_fun: null,
        layout: null,
        valor: {
          id_esocial_categoria: null,
          id_fdt: null,
          matricula: null,
          consulta: {
            aptidao: 186,
            id_tipo_aso: 47,
            aso_dt: this.$utilidade.toDate(null, true),
          },
          medico: {},
          responsavel_pcmso: {},
          responsavel:{},
          ambiente:{
            dtIniCondicao:null,
            dscAtivDes:null,
          },
          exames: [],
          riscos: [],
        },
      },
    };
  },

  mounted() {
    this.formataLista();
    this.getEstados();
    this.getCategoria();
    this.getEmpresa();
    this.initialize();
  },

  methods: {
    close() {
      this.parent.showNovoXml = false;
    },

    initialize() {
      this.formData = {
        id: 0,
        funcionario: null,
        empresa: null,
        id_emp: null,
        id_fun: null,
        layout: null,
        valor: {
          id_esocial_categoria: null,
          id_fdt: null,
          matricula: null,
          consulta: {
            aptidao: 186,
            id_tipo_aso: 47,
            aso_dt: this.$utilidade.toDate(null, true),
          },
          medico: {},
          responsavel_pcmso: {},
          responsavel:{},
          ambiente:{
            dtIniCondicao:null,
            dscAtivDes:null,
          },
          exames: [],
          riscos: [],
        },
      };
      if (this.parent.formDataXml && this.parent.formDataXml.id) {
        this.bind.funcionarios = [this.parent.formDataXml.funcionario];
        this.bind.empresas = [this.parent.formDataXml.empresa];

        this.formData = {
          id: this.parent.formDataXml.id,
          id_emp: this.parent.formDataXml.empresa.id,
          id_fun: this.parent.formDataXml.funcionario.id,
          funcionario: this.parent.formDataXml.funcionario,
          empresa: this.parent.formDataXml.empresa,
          layout: this.parent.formDataXml.layout,
          valor: this.parent.formDataXml.esocial_avulso.valor,
        };

        if (
          !this.formData.valor.responsavel_pcmso ||
          !this.formData.valor.responsavel_pcmso.nome
        ) {
          this.formData.valor.responsavel_pcmso = {
            nome: null,
            crm: null,
            crm_uf: null,
          };
        }

        this.formData.id_fun = this.parent.formDataXml.funcionario.id;
      }
    },

    setFuncionario(obj) {

      console.log('objobjobj',obj)
      if (obj) {
        this.formData.id_fun = obj.id;
        this.formData.matricula = obj.mat;
        this.formData.id_esocial_categoria = obj.id_esocial_categoria;

        if(obj.funcao){
          this.formData.valor.ambiente.dscAtivDes = obj.funcao.descricao;
        } 
       
      }
    },

    setEmpresa(obj) {
      if (obj) {
        this.formData.id_emp = obj.id;
        this.getFuncionario();
        this.getFdt();
      }
    },

    getEstados() {
      this.bind.estados = [];

      this.$root.$request.get("common/estado", null, true).then((result) => {
        console.log("resultresultresult", result);
        if (result.status == 200) {
          result.data.forEach((element) => {
            this.bind.estados.push({ id: element.uf, nome: element.uf });
          });
        }
      });
    },

    getCategoria(_search) {
      this.bind.categorias = [];
      this.bind.loadingCategoria = false;

      this.$root.$request
        .get("esocial/tabelas/conteudo/1", {
          search: _search,
          pagination: 100,
        })
        .then((result) => {
          this.bind.loadingCategoria = false;

          if (result.status == 200) {
            result.data.data.forEach((element) => {
              let item = {
                id: element.id,
                nome: element.codigo + " - " + element.nome,
              };

              if (item.nome.length > 50) {
                item.nome = item.nome.substring(0, 100);
              }

              this.bind.categorias.push(item);
            });
          }
        });
    },

    getTabelas() {
      let tabelas = [];

      this.parent.config.list.esocial_tabela.forEach((element) => {
        if (["S-2220", "S-2240"].indexOf(element.codigo) != -1) {
          tabelas.push({
            id: element.codigo,
            nome: element.codigo + " - " + element.nome,
          });
        }
      });

      return tabelas;
    },

    getEmpresa(_search) {
      this.bind.empresas = [];
      this.bind.loadingEmpresa = false;

      this.$root.$request
        .get("empresa", {
          search: _search,
          pagination: 100,
        })
        .then((result) => {
          this.bind.loadingFuncionario = false;

          if (result.status == 200) {
            this.bind.empresas = result.data.data;
          }
        });
    },

    getFuncionario(_search) {
      this.bind.funcionarios = [];
      this.bind.loadingFuncionario = false;

      this.$root.$request
        .get("empresa/funcionario/" + this.formData.id_emp, {
          search: _search,
          pagination: 100,
        })
        .then((result) => {
          this.bind.loadingFuncionario = false;

          if (result.status == 200) {
            this.bind.funcionarios = result.data.data;
          }
        });
    },

    getFdt() {
      if (!this.formData.id_emp) return;

      this.bind.loadingFdt = true;
      this.bind.fdt = [];

      this.$root.$request.get("pcmso/fdt/"+this.formData.id_emp, { pagination: 100 }).then((result) => {

        this.bind.loadingFdt  = false;
        console.log('fdt',result)

        if (result.status == 200) {
          result.data.data.forEach(element => {
            this.bind.fdt.push({id:element.id,nome:element.pcmso+' ('+element.descricao+')'})
          });
        }
      });
    },

    formataLista: function () {
      if (!this.parent || !this.parent.response) return;

      var result = this.parent.response;

      this.parent.tableHead = this.tableHead;

      if (!result.data || !result.data.data) {
        this.parent.tableData = [];
        return;
      }

      var tableData = [],
        arrData = result.data.data;

      for (var i = 0; i < arrData.length; i++) {
        arrData[i]._nome =
          arrData[i].empresa.nome + " - " + arrData[i].funcionario.nome;
        arrData[i].funcao = arrData[i].funcionario.funcao
          ? arrData[i].funcionario.funcao
          : null;
        arrData[i].fdt = arrData[i].funcionario.fdt
          ? arrData[i].funcionario.fdt
          : null;
        arrData[i].consulta = arrData[i].consulta ? arrData[i].consulta : null;

        let lote = "";

        if (arrData[i].lote) {
          lote = "<span>";
          lote +=
            '<span style="color:' +
            (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") +
            '"><i class="fa fa-plus"></i> Lote inclusão ' +
            arrData[i].lote +
            "</span>";
          lote += "</span>";
        }

        if (arrData[i].lote_exclusao) {
          lote +=
            '<br><a target="_blank" href="/esocial/lotes/' +
            arrData[i].lote_exclusao +
            '">';
          lote +=
            '<span style="color:' +
            (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") +
            '"><i class="fa fa-times"></i> Lote exclusão ' +
            arrData[i].lote_exclusao +
            "</span>";
          lote += "</a>";
        }
        var item = {
          layout: arrData[i].layout + "<br><b>Avulso</b>",
          empresa: arrData[i].empresa.nome,
          funcionario: arrData[i].funcionario.nome,
          funcao: arrData[i].funcao ? arrData[i].funcao.nome : null,
          tipo_status: arrData[i].tipo_status
            ? arrData[i].tipo_status.descricao
            : null,
          id: arrData[i].id,
          lote: lote ? lote : "----",
          recibo:
            '<span style="color:' +
            (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") +
            '">' +
            (arrData[i].recibo ? arrData[i].recibo : "---") +
            "</span>",
          updated_at:
            '<span style="color:' +
            (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") +
            '">' +
            this.toDate(arrData[i].updated_at, false) +
            "</span>",
          dt_cad:
            '<span style="color:' +
            (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") +
            '">' +
            this.toDate(arrData[i].created_at, false) +
            "</span>",
          _data: arrData[i],
          buttons: [],
          options: {
            disable_delete:
              arrData[i].tipo_status &&
              [332, 330].indexOf(arrData[i].tipo_status.id) != -1 &&
              arrData[i].recibo &&
              this.$root.$session.validarPermissao(586)
                ? false
                : true,
          },
        };

        item.buttons.push({
          icon: "fa fa-pencil",
          color: "default",
          title: "Editar",
          style: "color:#568cdd",
          click: this.parent.onEditXml,
        });

        if (!arrData[i].recibo && !arrData[i].xml) {
          item.buttons.push({
            icon: "fa fa-file-text-o",
            color: "default",
            title: "Gerar arquivo XML",
            style: "color:#e03a3a",
            click: this.parent.onEdit,
          });
        } else {
          item.buttons.push({
            icon: "fa fa-file-text-o",
            color: "default",
            title: "Baixar arquivo XML",
            style: "color:#34c142",
            click: this.parent.onDownloadXML,
          });

          if (!arrData[i].lote) {
            item.buttons.push({
              icon: "fa fa-file-archive-o",
              color: "default",
              title: "Gerar novo lote para esse arquivo",
              style: "color:#666",
              click: this.parent.onGerarLote,
            });
          }

          if (!arrData[i].recibo) {
            item.buttons.push({
              icon: "fa fa-refresh",
              color: "default",
              title: "Atualizar arquivo XML",
              style: "color:#568cdd",
              click: this.parent.onEdit,
            });
          }
        }

        if (
          (arrData[i].avulso == "1" &&
            [328].indexOf(arrData[i].tipo_status.id) != -1) ||
          (arrData[i].recibo &&
            arrData[i].tipo_status &&
            [332, 335].indexOf(arrData[i].tipo_status.id) != -1)
        ) {
          item.buttons.push({
            icon: "fa fa-times-circle",
            color: "default",
            title: "Excluir arquivo XML",
            style: "color:#d82d2d",
            click: this.parent.onDelete,
          });
        }

        //LOGS
        if (arrData[i].log_erro.length || arrData[i].log_warning.length) {
          item.buttons.push({
            icon: "fa fa-exclamation-triangle faa-flash animated",
            color: "default",
            title:
              item._data.log_erro.length +
              item._data.log_warning.length +
              " conflito(s) encontrado(s)",
            style: "color:" + (arrData[i].log_erro.length ? "red" : "#ff8300"),
            click: this.parent.onLogs,
          });
        }

        tableData.push(item);
      }

      this.parent.tableData = tableData;
      this.parent.pagination = result.data;
    },

    salvar() {
      this.$root.$loading.set(true);
      this.$root.$request
        .post("esocial/avulso/editar", this.formData)
        .then((result) => {
          this.$root.$loading.set(false);

          if (result.status == 200) {
            //this.$root.$message("Procedimento já foi inserido");
            this.parent.showNovoXml = !this.parent.showNovoXml;
            this.parent.getEsocial();
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.esocial-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1500;
}

.esocial-modal {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25);
  width: 620px;
  max-width: 92vw;
  max-height: 85vh;
  overflow: hidden;

  &--wide {
    width: 90%;
    max-width: 780px;
  }
}

.esocial-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 22px;
  border-bottom: 3px solid rgba(168, 121, 31, 0.45);
}

.esocial-modal__title {
  font-size: 15px;
  font-weight: 700;
  color: #1f2329;
}

.esocial-modal__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 50%;
  background: #f1f2f4;
  color: #6b7280;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.15s, color 0.15s;

  &:hover {
    background: #e4e7ed;
    color: #1f2329;
  }
}

.esocial-modal__body {
  padding: 20px 22px;
  overflow-y: auto;
  flex: 1 1 auto;
}

.esocial-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 16px 22px;
  border-top: 1px solid #eef0f2;
}

.esocial-search__btn {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  box-sizing: border-box;
  padding: 0 14px;
  border: 1px solid #e4e7ed;
  background: #fff;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: background-color 0.15s, border-color 0.15s;

  &:hover {
    background: #f7f8f9;
  }

  &--filter {
    position: relative;
    color: rgb(168, 121, 31);
    border-color: #f0dfb8;
    background: #fdf8ee;

    &:hover {
      background: #f5e6c3;
    }
  }
}

.esocial-modal-fade-enter-active,
.esocial-modal-fade-leave-active {
  transition: opacity 0.2s ease;
}

.esocial-modal-fade-enter,
.esocial-modal-fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// s0000.vue?e8351932